const moduleRoute = {
  path: '/itens',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('@/views/Items/ItemsReact.vue')
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
